var exports = {
  "w": "YunblyAuthBrand.module__brand___RzV4en",
};

module.exports = exports;
